module.exports = __webpack_public_path__ + "img/racecourse-mauritius-turf-1500.48a4fa2d.svg";